module.exports = __webpack_public_path__ + "dist/img/how-it-works-engine.2d9af2f6.svg";